import qc from 'qc'
import { scripts } from '@ps/bridge/qc/scripts/index'
import { isGroup, isIvGroup } from '../base'
export interface AudioScript {
  sourceAudioDuration: number // 原音效时长
  sourceAudioUrl: string // 原音效url
  audioUrl: string // 当前音效 URL
  clipStartTime: number // 上一次裁剪起始时间，单位毫秒
  clipEndTime: number // 上一次裁剪结束时间，单位毫秒
  volume: number // 音量
  autoPlay: boolean // 是否自动播放
  loopNumber: number // 循环播放次数
  loop: boolean // 是否循环播放
  size: number // 文件大小
}

/**
 * ps.Audio
 * @param node
 * @param addScriptIfScriptNotExist
 */
export const getScript = (
  node: qc.Node,
  addScriptIfScriptNotExist = true,
): AudioScript | undefined => {
  const config: AudioScript | undefined = node.getScript(scripts.audio.name)
  if (config) {
    return config
  }
  if (addScriptIfScriptNotExist) {
    // 互动视频不明原因，在其他类型的节点上添加了音频脚本，暂时复现不了，所以这里兜底判断只有qc.Node且不是组节点时才加音频脚本
    if (node.class === 'qc.Node' && !isGroup(node) && !isIvGroup(node)) {
      return node.addScript(scripts.audio.name) as AudioScript
    }
    return undefined
  }
  return config
}
